import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";

import Layout from 'pages/Layout';
import { useAppSelector } from "./redux/hooks";
import PrivateRoute from 'components/common/PrivateRoute/PrivateRoute';
import { getToken } from "./redux/pages/Login/loginSlice";
import { loadAuthConfig } from "./redux/pages/Login/authConfigSlice";

import './App.scss';
import { setServiceClassDispatcher, setSessionExpiryMessage } from 'service/HttpService';
import Help from 'components/Header/Help/Help';
import InformationBox from 'components/common/Message/InformationBox/InformationBox'; 
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { fetchLoggedInUserDetails } from 'redux/pages/Administration/administrationSlice';

const RouteGuard = ({ component: Component }) => <PrivateRoute><Component /></PrivateRoute>

function App() {

  const dispatch = useDispatch<any>();
  setServiceClassDispatcher(dispatch);
  const token = useAppSelector((state) => state.login.accessToken);
  const authConfigLoaded = useAppSelector((state) => state.authConfig.isLoaded);
  const appBaseURL = (window as any).envSettings.appBaseUrl;
  const [showHelp, setShowHelp] = useState<boolean>(false);
  const [pathName, setPathName] = useState('');
  const [message, setMessage] = useState<any>();
  const [displayInfoModal, setDisplayInfoModal] = useState<boolean>(false)
  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const themeMode = useAppSelector((state) => state.personalSettings.themeMode);
  const loggedInUserData = useAppSelector((state) => state.administration.loggedInUserDetails);

 useEffect(() => {
    // Check for the "body" element and its class list
    if (document.body) {
      if (themeMode === 1 ) {
        document.body.classList.add("dark-mode");
        document.body.classList.remove("classic-mode");
      } else {
        document.body.classList.add("classic-mode");
        document.body.classList.remove("dark-mode");
      }
    }
  }, [themeMode]);

   useEffect(() => {
    // Check for the "body" element and its class list
    if (document.body) {
      if (loggedInUserData?.userDefaults?.mode===1 ) {
        document.body.classList.add("dark-mode");
        document.body.classList.remove("classic-mode");
      } else {
        document.body.classList.add("classic-mode");
        document.body.classList.remove("dark-mode");
      }
    }
  }, [loggedInUserData]);

  useEffect(() => {
    dispatch(loadAuthConfig());
  }, []);

  useEffect(() => {
    if (!authConfigLoaded) return;
    if (token == null) {
      dispatch(getToken());
    } else {
      if (token.accessToken == null) {
        document.location.href = `${appBaseURL}/api/v1/auth/signin`;
      }
      else {
        dispatch(fetchLoggedInUserDetails());
      }
    }
  }, [token, authConfigLoaded]);

  useEffect(() => {
    document.addEventListener('keydown', handleF1Key);
  }, [])

  const renderFooter = () => {
      return (
        <>
          <Button label="OK" onClick={() => { setShowModal(false); navigate(0) }} className='submit-btn' autoFocus />
        </>
      );
    }
  
    useEffect(() => {
      // Listener for changes in localStorage across tabs
      const handleStorageChange = (event) => {
        if (event.key === "LocalSiteId") {
          if (localStorage.getItem("SessionSiteId") !== localStorage.getItem("LocalSiteId")) {
            setShowModal(true);
          }
        }
      };
      window.addEventListener("storage", handleStorageChange);
      // Cleanup the event listener on unmount
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }, []);   

  const handleF1Key = (e) => {
    if (e.key == 'F1') {
      e.preventDefault()
      const pathNameWithOutSlash = window.location.pathname.replace("/", '');
      setPathName(pathNameWithOutSlash)
      setShowHelp(true) 
    }
  }

  const signOutUser = () => {
    (window as any).location =`${appBaseURL}/api/v1/auth/signout`
  }

   const onClose = () => {
   setShowModal(false); 
   navigate(0);
  }

  setSessionExpiryMessage(() => {
    setMessage("Your Session has timed out. You will be directed to Login page.");
    setDisplayInfoModal(true);
  }); 

  return (
    token == null || token.accessToken == null ?
      <div className="app-container">
        Validating User Session
      </div> :
      <div className="app-container">
        <RouteGuard component={Layout} />
        {showHelp ? (<Help
          isGlobal={true}
          currentPage={pathName}
          showModal={showHelp}
          setShowModal={setShowHelp}
        />) : null}
       <InformationBox
        showInfoModal={displayInfoModal}
        setShowInfoModal={setDisplayInfoModal}
        message={message}
        okOnClick={signOutUser}
        onHide={signOutUser}
        />
        {showModal && <Dialog
          header="Tech Advance +"
          visible={true}
          style={{ width: '35vw' }}
          footer={renderFooter()}
          onHide={onClose}
          className='delete-modal'
        >
          <p className='content'>Active Site has been changed. Click the OK button to refresh and continue.</p>
        </Dialog>}
      </div>
  )
}

export default App;